'use strict';

angular.module('formonlineApp').service('ListUtils', [
    function () {

        this.isStringInList = function (list, string) {
            if (!list || !string) {
                return false;
            }
            return list.filter(function(x) { return x === string}).length !== 0;
        }

    }]);
